module.exports = __webpack_public_path__ + "static/media/female.29b1a502.jpg";